const keyCodes = {
  arrows: {
    up: 38,
    down: 40,
  },
  enter: 13,
  space: 32,
};

export default keyCodes;
